import React,{useMemo} from "react";
import { Box, Flex, Spinner } from "@chakra-ui/react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./Styles/AgGridWrapper.css";

function AgGridWrapper({
  rowData = [],
  columnDefs = [],
  loading = false,
  onGridReady,
  onFilterChanged,
  height = "590px",
  rowHeight,
  extraGridProps = {},
  noRowsMessage = "No data available. Please load data to view results.",
  
}) {

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      filterParams: { maxNumConditions: 1, buttons: ["reset"] },
      resizable: true,
      minWidth: 120,
      suppressHeaderMenuButton: false,
      menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderMenuButton: false,
      rowDrag: false,   
      suppressMovable: true, 
      cellStyle: {                       
      display: "flex",
      alignItems: "center",
      lineHeight: "normal",
     },
   }),
 
    []
  );
 
  const computedRowHeight =
    rowHeight ?? (window.innerWidth < 768 ? 60 : 64);
 
  const overlayNoRowsTemplate = `
    <span style="color:#9ca3af;font-size:15px;font-weight:500;">
      ${noRowsMessage}
    </span>`;
 
  return (
    <Box className="ag-theme-alpine" style={{ height, width: "100%" }}>
      {loading ? (
        <Flex justify="center" align="center" h="100%">
          <Spinner
            size={{ base: "xl", md: "2xl" }}
            color="red.500"
            thickness="15px"
          />
        </Flex>
      ) : (
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onGridReady={onGridReady}
          onFilterChanged={onFilterChanged}
          animateRows={false}
          rowHeight={computedRowHeight}
          enableCellTextSelection={true}
           suppressCellFocus={true}  
          ensureDomOrder={true}
          suppressRowClickSelection={true}
          overlayNoRowsTemplate={overlayNoRowsTemplate}
          {...extraGridProps}  
          domLayout="normal"
          style={{ height: "100%", width: "100%" }}
                
        />
      )}
    </Box>
  );
}
 
export default AgGridWrapper;
